import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { publicGet } from '@/lib/api/publicClient';
import { publicPaymentEndpoints } from '@/lib/api/endpoints';
import type { TipPageData } from '@/types/onlineBooking';

export const tipPageKeys = {
  all: () => ['public', 'tip'] as const,
  detail: (id: string) => [...tipPageKeys.all(), id] as const,
};

export function useTipPageData(
  id: string,
  /** Poll while an inline (ACH) tip attempt is settling. */
  options?: { refetchInterval?: UseQueryOptions<TipPageData>['refetchInterval'] },
) {
  return useQuery<TipPageData>({
    queryKey: tipPageKeys.detail(id),
    queryFn: () => publicGet<TipPageData>(publicPaymentEndpoints.tipPage(id)),
    enabled: !!id,
    staleTime: 60_000,
    refetchInterval: options?.refetchInterval ?? false,
  });
}
